import { PlanningPage } from "./pages/PlanningPage";

export function App() {
  const planningHref = `${window.location.pathname}${window.location.search}`;
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <header className="topbar">
        <a className="brand" href={planningHref} aria-label="BoostWare Pick Planner - Planning">
          <span className="brand-mark" aria-hidden="true">
            <img src="/boostware-logo.png" alt="" />
          </span>
          <span>
            <strong>BoostWare</strong>
            <small>Pick Planner</small>
          </span>
        </a>
        <nav aria-label="Primary navigation">
          <a className="is-active" href={planningHref} aria-current="page">
            Planning
          </a>
        </nav>
        <span className="version-badge">Planner V2</span>
      </header>
      <main id="main-content" tabIndex={-1}>
        <PlanningPage />
      </main>
      <footer>
        Handoff data is available only for a limited time and is not kept as plan history.
      </footer>
    </div>
  );
}
